import { useContext, useState, useEffect } from "react";
import { Button, Divider, Modal } from "@mantine/core";
import { FoldersContext, searchFolders } from "../contexts/FoldersContext";
import FolderVTree from "./FolderVTree";
import ModalFooter from "./ModalFooter";
import FoldersHeader from "./FoldersHeader";
import { useViewportSize } from "@mantine/hooks";

const MoveFolderModal = ({ opened, onClose, folder }) => {
  const { height } = useViewportSize();
  const { moveFolder, flatFolders, setSearching } = useContext(FoldersContext);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [saving, setSaving] = useState(false);
  const [localSearchQuery, setLocalSearchQuery] = useState("");
  const [localSearchResults, setLocalSearchResults] = useState([]);

  useEffect(() => {
    if (opened) {
      setSelectedFolder(null);
      setLocalSearchQuery("");
      setLocalSearchResults([]);
    }
  }, [opened]);

  useEffect(() => {
    if (localSearchQuery.trim() !== "") {
      setSearching(true);
      setTimeout(() => {
        const results = searchFolders(localSearchQuery, flatFolders);
        setLocalSearchResults(results);
        setSearching(false);
      }, 0);
    } else {
      setLocalSearchResults([]);
      setSearching(false);
    }
  }, [localSearchQuery, flatFolders, setSearching]);

  const handleMove = async () => {
    setSaving(true);
    await moveFolder(folder?.value, selectedFolder?.value);
    setSaving(false);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      keepMounted={false}
      onClose={onClose}
      centered
      title={`Move "${folder?.label}" to ${
        selectedFolder?.label ? `"${selectedFolder.label}"` : "..."
      } `}
      styles={{ title: { fontWeight: 600 } }}
      size="md"
    >
      <Divider />
      <FoldersHeader
        showTitle={false}
        showMenu={false}
        localSearch={localSearchQuery}
        onLocalSearchChange={setLocalSearchQuery}
        data-testid="move-folder-modal-folders"
      />
      <FolderVTree
        height={height - 350}
        width="100%"
        itemSize={32}
        enableSelect
        selected={selectedFolder}
        onSelect={setSelectedFolder}
        disabledFolderActionMenuItems={["move"]}
        searchResults={localSearchResults}
        searchQuery={localSearchQuery}
        onSearchClear={() => {
          setLocalSearchQuery("");
          setLocalSearchResults([]);
        }}
      />
      <ModalFooter>
        <Button variant="outline" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          onClick={handleMove}
          loading={saving}
          disabled={!selectedFolder}
        >
          Move
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MoveFolderModal;
